import React from 'react';

const IconAvantti1: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M42.8505 9.28579C42.0474 7.8755 40.4932 6.99988 38.7946 6.99988C37.0146 6.99988 35.3618 7.90183 34.4815 9.35397L24.169 27.3966L13.8777 9.38969L13.8564 9.35397C12.9761 7.90183 11.3234 6.99988 9.54295 6.99988C7.87074 6.99988 6.33886 7.86179 5.54551 9.24971C4.80807 10.5399 4.8189 12.0761 5.57437 13.3594L20.9984 39.5506L21.015 39.5787C21.6778 40.6531 22.8568 41.2949 24.169 41.2949C25.4811 41.2949 26.6602 40.6531 27.3229 39.5787L42.8116 13.4532C43.5822 12.1536 43.5966 10.5954 42.8505 9.28579Z" fill="#AD1781" />
  </svg>
);

export default IconAvantti1;
